import { authenticatedPost } from '../../../../../../api/request';

export default async function createServices(newService, setErrorMessage) {
    const onFail = () => setErrorMessage('Se produjo un error al guardar un nuevo servicio.');
    const url = `/doctor-profile-management/doctor-services`;
    return await authenticatedPost(url, onFail, newService);
}